import { Role } from '../../../../types/auth';

// V4 D11: Tablet sólo opera el timer; sólo Coex/SuperAdmin crean RVs;
// históricos/descargas para los roles supervisores y Tablet.
type RouteItem = {
  title: string;
  path: string;
  permissions: Role[];
  subItems?: { text: string; path: string; permissions: Role[] }[];
};

export const getData = (t: (key: string) => string, role?: Role | string) => {
  const all: RouteItem[] = [
    {
      title: t('pages:surveillance.generalView'),
      path: '',
      // Capataz (fix 2026-07-20): clon de Coex, faltaba en todo el menú RV.
      permissions: [
        Role.SuperAdmin,
        Role.Coex,
        Role.Capataz,
        Role.RoomTeam,
        Role.Tablet,
      ],
      subItems: [
        {
          text: t('pages:surveillance.newRoute'),
          path: 'new-route',
          // D11 (fix 2026-07-04): Tablet SÍ crea RVs (el comentario anterior
          // contradecía la matriz del spec); RoomTeam NO.
          permissions: [Role.SuperAdmin, Role.Coex, Role.Capataz, Role.Tablet],
        },
      ],
    },
    // "Buscar y crear históricos" se movió al menú Informes (/reporting),
    // como el resto de históricos (reorg 2026-07-04).
  ];

  // Fix 2026-07-04: SIEMPRE devolver `permissions` en los ítems (como
  // WorkOrdersLayout/routes). El HamburguerMenu llama getData(t) sin rol y
  // su filterAllowedRoutes DESCARTA ítems sin permissions — al quitarlos
  // aquí, el menú hamburguesa del RV salía vacío.
  if (!role) {
    return all;
  }

  return all
    .filter((item) => item.permissions.includes(role as Role))
    .map((item) => ({
      ...item,
      subItems: item.subItems?.filter((sub) =>
        sub.permissions.includes(role as Role)
      ),
    }));
};
